type PotokMainModule = {
  startPotokApp: () => void;
  activatePotokPlatformBridge?: () => void;
};

type BootstrapDependencies = {
  loadMain: () => Promise<PotokMainModule>;
  loadPlatformSdk: () => Promise<void>;
  onMainReady?: () => void;
};

/** Downloads the app graph beside MAX SDK and mounts Potok as soon as its own
 * graph is ready. MAX launch data is available from the signed launch hash,
 * so a slow SDK transport must not hold the whole Mini App behind its network
 * timeout. Host-only capabilities are activated once the SDK settles. */
export async function bootstrapPotok({ loadMain, loadPlatformSdk, onMainReady }: BootstrapDependencies): Promise<void> {
  const mainPromise = loadMain();
  const platformPromise = loadPlatformSdk().catch(() => undefined);
  const { startPotokApp, activatePotokPlatformBridge } = await mainPromise;
  onMainReady?.();
  startPotokApp();
  await platformPromise;
  activatePotokPlatformBridge?.();
}
